// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3omID","signatureButtonsRight":"ModalSign_signatureButtonsRight__2fwQO"};